module.exports = __webpack_public_path__ + "img/icon_wait_bg@2x.bd4066d4.png";